module.exports = __webpack_public_path__ + "img/7.3ce8b960.jpeg";